/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var t = "lit-localize-status";
export { t as LOCALE_STATUS_EVENT };